// src/components/admin/TenantSelect.tsx
import type { TenantUsageRow } from '@/types/admin';

interface Props {
  tenants: Pick<TenantUsageRow, 'tenantId' | 'name'>[];
  value: string | null; // null = "tutti i tenant"
  onChange: (tenantId: string | null) => void;
}

export const TenantSelect = ({ tenants, value, onChange }: Props) => (
  <select
    className="border rounded px-3 py-1.5 text-sm bg-background"
    value={value ?? '__all__'}
    onChange={(e) => onChange(e.target.value === '__all__' ? null : e.target.value)}
  >
    <option value="__all__">Tutti i tenant</option>
    {tenants.map((t) => (
      <option key={t.tenantId ?? 'no-tenant'} value={t.tenantId ?? ''}>
        {t.name ?? '(no tenant)'}
      </option>
    ))}
  </select>
);
